import { render, staticRenderFns } from "./TelaQrCodePix.vue?vue&type=template&id=c5d69852&"
import script from "./TelaQrCodePix.vue?vue&type=script&lang=js&"
export * from "./TelaQrCodePix.vue?vue&type=script&lang=js&"
import style0 from "./TelaQrCodePix.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports